module.exports = __webpack_public_path__ + "img/pluse-shop-icon.14ef095f.svg";